<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12" lg="12" xl="8">
        <template v-if="showSkeleton">
          <v-skeleton-loader
            class="mb-6"
            type="card-avatar, article, list-item-avatar, list-item-avatar"
          ></v-skeleton-loader>
        </template>
        <template v-if="!showSkeleton && profile != null">
          <v-alert v-model="notifyErr" type="error" text dismissible>{{
            errMsg
          }}</v-alert>

          <!-- <v-sheet> -->
          <!-- <v-divider></v-divider> -->
          <!-- <v-sheet class="content-color-sheet pa-4 mt-2"> -->
          <template>
            <v-row class="py-4">
              <v-col
                cols="12"
                sm="12"
                md="8"
                lg="8"
                xl="8"
                offset-md="2"
                offset-lg="3"
                offset-xl="3"
              >
                <v-row>
                  <v-col cols="12" md="12" lg="4" xl="4" class="text-end">
                    <div>
                      <v-hover v-slot="{ hover }">
                        <a>
                          <v-badge
                            avatar
                            bordered
                            overlap
                            bottom
                            offset-x="32"
                            offset-y="32"
                          >
                            <template v-slot:badge>
                              <v-avatar :size="30">
                                <v-icon>mdi-pencil-outline</v-icon>
                              </v-avatar>
                            </template>

                            <image-input v-model="avatar">
                              <div slot="activator">
                                <v-avatar
                                  :size="120"
                                  v-ripple
                                  v-if="!profile.info.image"
                                  class="grey lighten-3 mb-3"
                                >
                                  <span class="grey--text"
                                    >Click to add profile</span
                                  >
                                </v-avatar>
                                <v-avatar
                                  :size="120"
                                  v-ripple
                                  v-else
                                  class="mb-3"
                                >
                                  <v-img
                                    v-if="avatar"
                                    :src="avatar.imageURL"
                                    alt="avatar"
                                  >
                                  </v-img>
                                  <v-img
                                    v-else-if="!avatar && profile.info.image"
                                    :src="profile.info.image"
                                    alt="avatar"
                                    ><v-expand-transition>
                                      <div
                                        v-if="hover"
                                        class="d-flex transition-fast-in-fast-out grey darken-4 v-card--reveal white--text font-weight-bold"
                                        style="height: 100%"
                                      >
                                        Change profile
                                      </div>
                                    </v-expand-transition></v-img
                                  >
                                </v-avatar>
                              </div>
                            </image-input>
                            <!-- <v-slide-x-transition>
                            <div v-if="avatar && saved == false">
                              <v-btn outlined @click="avatar = null"
                                >Cancel</v-btn
                              >
                            </div>
                          </v-slide-x-transition> -->
                          </v-badge>
                        </a>
                      </v-hover>
                    </div>
                  </v-col>
                  <v-col class="container" cols="12" md="12" lg="8" xl="8">
                    <div class="line">
                      <template v-if="$vuetify.breakpoint.lgAndUp">
                        <div class="title">{{ profile.info.displayName }}</div>
                        <div class="subtitle-1 text--secondary">
                          {{ profile.info.username }}
                        </div>
                        <!-- <div class="mt-4">
                            <v-btn :color="$buttonColor" class="white--text">
                              <v-icon left>far fa-pencil</v-icon>Edit Profile
                            </v-btn>
                          </div> -->
                      </template>
                      <template v-else>
                        <div class="subtitle-1 text-center">
                          {{ profile.info.displayName }}
                        </div>
                        <div class="subtitle-2 text--secondary text-center">
                          {{ profile.info.username }}
                        </div>
                        <!-- <div class="mt-4 text-center">
                            <v-btn :color="$buttonColor" class="white--text">
                              <v-icon left>far fa-pencil</v-icon>Edit Profile
                            </v-btn>
                          </div> -->
                      </template>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
          <template>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col
                  class="py-0"
                  cols="12"
                  lg="3"
                  xl="3"
                  offset-lg="3"
                  offset-xl="3"
                >
                  <p class="mb-2">First name</p>
                  <v-text-field
                    v-model="profile.info.firstName"
                    :rules="[requiredRule]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" lg="3" xl="3">
                  <p class="mb-2">Last name</p>
                  <v-text-field
                    v-model="profile.info.lastName"
                    :rules="[requiredRule]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="py-0"
                  cols="12"
                  lg="3"
                  xl="3"
                  offset-lg="3"
                  offset-xl="3"
                >
                  <p class="mb-2">Gender</p>
                  <v-select
                    v-model="profile.info.gender"
                    :items="genders"
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col class="py-0" cols="12" lg="3" xl="3">
                  <p class="mb-2">Contact Email</p>
                  <v-text-field
                    type="email"
                    outlined
                    dense
                    v-model="profile.info.email"
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="py-0"
                  offset-lg="3"
                  offset-xl="3"
                  cols="12"
                  lg="6"
                  xl="6"
                >
                  <p class="mb-2">Description</p>
                  <v-textarea
                    no-resize
                    outlined
                    rows="2"
                    v-model="profile.info.description"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row class="pb-4 text-center">
                <v-col class="pt-0" cols="12" md="12" lg="12" xl="12">
                  <v-btn
                    :color="$buttonColor"
                    class="text-capitalize white--text"
                    :loading="progressSave"
                    @click="saveChangeProfile"
                    :disabled="!valid"
                    >Save Change
                  </v-btn>
                  <span class="mx-2"></span>
                </v-col>
              </v-row>
              <!-- save password -->
            </v-form>
            <v-form v-model="pwdValid" v-if="profile.info.username">
              <div class="pt-6 pb-4 title txt-center">Change Password</div>
              <v-row class="pt-4">
                <v-col
                  class="py-0"
                  cols="12"
                  lg="3"
                  xl="3"
                  offset-lg="3"
                  offset-xl="3"
                >
                  <p class="mb-2">Username</p>
                  <span class="body-1 pt-2"
                    ><b>{{ profile.info.username }}</b></span
                  >
                </v-col>
                <v-col class="py-0" cols="12" lg="3" xl="3">
                  <p class="mb-2">Old Password</p>
                  <v-text-field
                    v-model="pwd.old"
                    type="password"
                    placeholder="Old Password"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col
                  class="py-0"
                  cols="12"
                  lg="3"
                  xl="3"
                  offset-lg="3"
                  offset-xl="3"
                >
                  <p class="mb-2">New Password</p>
                  <v-text-field
                    v-model="pwd.newPwd"
                    placeholder="New Password"
                    type="password"
                    outlined
                    dense
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" lg="3" xl="3">
                  <p class="mb-2">Confirm Password</p>
                  <v-text-field
                    v-model="pwd.newPwdConfirm"
                    type="password"
                    placeholder="Confirm Password"
                    outlined
                    dense
                    :rules="[requiredRule, conFirmPasswordRules]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="12" lg="12" xl="12">
                  <v-btn
                    :color="$buttonColor"
                    class="text-capitalize white--text"
                    :loading="progressSave"
                    @click="changePassword"
                    :disabled="!pwdValid || pwd.old == '' || pwd.newPwd == ''"
                    >Save Password
                  </v-btn>
                  <span class="mx-2"></span>
                </v-col>
              </v-row>
            </v-form>
            <v-form v-else>
              <div class="pt-6 pb-4 title txt-center">Login With</div>
              <v-row class="pt-4">
                <v-col
                  class="py-0"
                  cols="12"
                  lg="3"
                  xl="3"
                  offset-lg="3"
                  offset-xl="3"
                >
                  <v-chip
                    v-if="profile.info.login_facebook"
                    class="ma-0"
                    color="#4267B2"
                    label
                    outlined
                  >
                    <v-icon left> mdi-facebook </v-icon>
                    {{
                      `${profile.info.login_facebook.firstName} ${profile.info.login_facebook.lastName}`
                    }}
                  </v-chip>
                  <v-chip
                    v-if="profile.info.login_google"
                    class="ma-0"
                    color="#DB4437"
                    label
                    outlined
                  >
                    <v-icon left> mdi-google </v-icon>
                    {{
                      `${profile.info.login_google.firstName} ${profile.info.login_google.lastName}`
                    }}
                  </v-chip>
                  <v-chip
                    v-if="profile.info.login_appleID"
                    class="ma-0"
                    color="#000000"
                    label
                    outlined
                  >
                    <v-icon left> mdi-apple </v-icon>
                    {{
                      `${profile.info.login_appleID.firstName} ${profile.info.login_appleID.lastName}`
                    }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-form>
          </template>
          <!-- </v-sheet> -->
          <!-- </v-sheet> -->
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import { EventBus } from "@/event-bus";
import ImageInput from "@/components//ImageInput.vue";
export default {
  components: {
    ImageInput: ImageInput,
  },
  data: () => ({
    avatar: null,
    saving: false,
    saved: false,
    notifyErr: false,
    errMsg: "",
    loading: false,
    profile: null,
    showSkeleton: true,
    valid: true,
    pwdValid: true,
    // isChangePwd: false,
    requiredRule: (v) => !!v || "This field is required",
    emailRule: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    progressSave: false,
    progressUpload: false,
    targetImg: null,
    pwd: {
      old: "",
      newPwd: "",
      newPwdConfirm: "",
    },
    genders: [
      {
        text: "--- Not set ---",
        value: null,
      },
      {
        text: "Male",
        value: "male",
      },
      {
        text: "Female",
        value: "female",
      },
    ],
    isOpenInsertfile: false,
  }),
  watch: {
    // isChangePwd(val) {
    //   if (!val) {
    //     this.pwd = {
    //       old: "",
    //       newPwd: "",
    //       newPwdConfirm: "",
    //     };
    //   }
    // },
  },
  mounted() {
    this.init();
  },
  computed: {
    conFirmPasswordRules() {
      let rule = true;
      // if (this.isChangePwd == true) {
      rule = (v) =>
        (!!v && v) === this.pwd.newPwd || "Please enter the matched password";
      // }
      return rule;
    },
  },
  methods: {
    init() {
      this.fetch();
    },
    fetch() {
      this.profile = null;
      this.showSkeleton = true;

      this.$http
        .get(`${this.$store.state.api}/account/tula/info`)
        .then((resp) => {
          if (resp.data.status == true) {
            this.profile = resp.data.result;
            const info = {
              companies: resp.data.result.info.companies,
              displayName: resp.data.result.info.displayName,
              email: resp.data.result.info.email,
              username: resp.data.result.info.username,
              firstName: resp.data.result.info.firstName,
              image: resp.data.result.info.image,
              isTeacher: resp.data.result.info.isTeacher,
              lastName: resp.data.result.info.lastName,
              _id: resp.data.result.info._id,
              setting: resp.data.result.setting,
              description: resp.data.result.description,
            };
            // this.$cookies.set("user_info", info);
            Vue.prototype.$userInfo = info;
            if (info.companies[0].connectToolsWith) {
              setGoogleAnalytic(
                info.companies[0].connectToolsWith.googleAnalytics
              );
            }
            EventBus.$emit("updateProfile");
          } else {
            this.profile = null;
          }
        })
        .catch((err) => {
          this.profile = null;
          this.errMsg = err.response.data.message;
          this.notifyErr = true;
        })
        .finally(() => {
          this.showSkeleton = false;
        });
    },
    saveChangeProfile() {
      if (this.avatar) {
        this.uploadImg();
      }

      this.updateProfile();
    },
    updateProfile() {
      this.progressSave = true;
      const data = {
        firstName: this.profile.info.firstName,
        lastName: this.profile.info.lastName,
        gender: this.profile.info.gender,
        image: this.profile.info.image,
        email: this.profile.info.email,
        description: this.profile.info.description,
        studentCode: "",
        identificationNumber: "",
      };
      this.$http
        .put(`${this.$store.state.api}/account/manage/update/editprofile`, data)
        .then((resp) => {
          if (resp.status == 200 && resp.data.status) {
            this.progressSave = false;
            this.fetch();
            this.editMode = false;
            // if (this.isChangePwd) {
            //   this.changePassword();
            // } else {
            //   this.progressSave = false;
            //   this.fetch();
            //   this.editMode = false;
            // }
            window.location.reload();
          } else {
            this.progressSave = false;
            this.errMsg = resp.data.message;
            this.notifyErr = true;
          }
        })
        .catch((err) => {
          this.progressSave = false;
          this.errMsg = err.response.data.message;
          this.notifyErr = true;
        });
    },
    changePassword() {
      if (this.pwd.newPwd == this.pwd.newPwdConfirm) {
        const params = {
          passwordold: this.pwd.old,
          passwordnew: this.pwd.newPwd,
        };
        this.$http
          .put(
            `${this.$store.state.api}/account/manage/update/editpassword`,
            params
          )
          .then((resp) => {
            if (resp.status == 200 && resp.data.status) {
              EventBus.$emit("signout");
            }
          })
          .catch((err) => {
            this.errMsg = err.response.data.message;
            this.notifyErr = true;
          })
          .finally(() => {
            this.progressSave = false;
          });
      } else {
        this.progressSave = false;
        this.errMsg = "New password is not match.";
        this.notifyErr = true;
      }
    },
    uploadImg() {
      console.log(this.avatar);
      console.log(this.avatar.file[0]);

      if (this.avatar.file != null) {
        let fd = new FormData();
        fd.append("fileupload", this.avatar.file[0]);

        this.progressUpload = true;
        this.$http
          .post(`${this.$store.state.api}/account/manage/update/image`, fd)
          .then((resp) => {
            if (resp.status == 200 && resp.data.status) {
              this.profile.info.image = resp.data.result.image;
              this.avatar = null;

              const info = {
                ...Vue.prototype.$userInfo,
                image: resp.data.result.image,
              };
              Vue.prototype.$userInfo = info;
              if (info.companies[0].connectToolsWith) {
                setGoogleAnalytic(
                  info.companies[0].connectToolsWith.googleAnalytics
                );
              }
              EventBus.$emit("updateProfile");
            } else {
              this.errMsg = resp.data.message;
              this.notifyErr = true;
            }
          })
          .catch((err) => {
            this.errMsg = err.response.data.message;
            this.notifyErr = true;
          })
          .finally(() => {
            this.progressUpload = false;
          });
      }
    },
    saveInfo() {
      this.isOpenInsertfile = false;
      this.fetch();
    },
    openInsertfile() {
      this.isOpenInsertfile = true;
      console.log("this.isOpenInsertfile", this.isOpenInsertfile);
      let tmpFileImg = null;
    },
  },
};
function setGoogleAnalytic(id) {
  if (id) {
    window.ga =
      window.ga ||
      function () {
        (ga.q = ga.q || []).push(arguments);
      };
    ga.l = +new Date();
    // Trace debugging
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/debugging
    // window.ga_debug = {trace: true}
    ga("create", id, "auto");
    // if (isLocalhost) {
    //   ga('set', 'sendHitTask', null)
    // }
  }
}
</script>
<style scoped lang="scss">
.txt-center {
  text-align: -webkit-center;
}
.container {
  position: relative;
}
.line {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.6;
  position: absolute;
  width: 100%;
}
.contactEmail {
  font-size: 12px;
  color: gray;
  font-style: italic;
}
</style>
<style lang="scss">
.sty-badge-edit {
  cursor: pointer;
  .v-badge__wrapper > .v-badge__badge {
    border-radius: 20px !important;
    font-size: 20px !important;
    height: 30px !important;
    min-width: 30px;
    .v-icon {
      color: white !important;
      font-size: 15px !important;
    }
  }
  .v-btn:not(.v-btn--round).v-size--default {
    height: 20px !important;
    min-width: 20px !important;
    padding: 0 0px !important;
  }
  .theme--light.v-btn.v-btn--has-bg {
    background-color: unset !important;
  }
  .v-btn--is-elevated {
    box-shadow: unset !important;
  }
}
</style>
